import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';
import IconEdit from 'components/icons/IconEdit';
import { colorBrand } from 'styles/layout/colors';
const PencilIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconEdit className="ml-[.3rem]" width={12} height={12} color={colorBrand} data-xc="PDPUpdateLocationIcon" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const PDPZipCodeWrapper = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="!text-base inline-flex flex-1 text-center">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
PDPZipCodeWrapper.propTypes = {
  children: PropTypes.node
};
const PDPZipCodeEditLocationUI = t0 => {
  const $ = _c(10);
  const {
    isLoading: t1,
    isUserInUS: t2,
    isZipCodeFromUserServiceable: t3,
    locationToShow,
    toggleUpdateZipCodeSidebar,
    zipCodeFromUser
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const isUserInUS = t2 === undefined ? true : t2;
  const isZipCodeFromUserServiceable = t3 === undefined ? true : t3;
  if (isLoading) {
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <PDPZipCodeWrapper><ProgressLoaderDots inline={true} grey={true} /></PDPZipCodeWrapper>;
      $[0] = t4;
    } else {
      t4 = $[0];
    }
    return t4;
  }
  if (zipCodeFromUser && !isZipCodeFromUserServiceable) {
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <PencilIcon />;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== toggleUpdateZipCodeSidebar) {
      t5 = <PDPZipCodeWrapper><button className="items-center flex focus-visible:outline-offset-4 focus:outline-0 text-brand hover:underline font-bold" onClick={toggleUpdateZipCodeSidebar} type="button" aria-label="Update your location">Edit zip code{t4}</button></PDPZipCodeWrapper>;
      $[2] = toggleUpdateZipCodeSidebar;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    return t5;
  }
  if (!isUserInUS || !locationToShow) {
    let t4;
    if ($[4] !== toggleUpdateZipCodeSidebar) {
      t4 = <PDPZipCodeWrapper><button className="items-center flex focus-visible:outline-offset-4 focus:outline-0 text-brand font-bold hover:underline" onClick={toggleUpdateZipCodeSidebar} type="button" aria-label="Add your location">Add zip</button></PDPZipCodeWrapper>;
      $[4] = toggleUpdateZipCodeSidebar;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PencilIcon />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== locationToShow || $[8] !== toggleUpdateZipCodeSidebar) {
    t5 = <PDPZipCodeWrapper>to{" "}<button data-xc="PDPUpdateLocationButton" className="items-center flex ml-1 mr-1 focus-visible:outline-offset-4 focus:outline-0 text-brand hover:underline font-bold" onClick={toggleUpdateZipCodeSidebar} type="button" aria-label="Update your location">{locationToShow}{t4}</button></PDPZipCodeWrapper>;
    $[7] = locationToShow;
    $[8] = toggleUpdateZipCodeSidebar;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
PDPZipCodeEditLocationUI.propTypes = {
  isLoading: PropTypes.bool,
  isUserInUS: PropTypes.bool,
  isZipCodeFromUserServiceable: PropTypes.bool,
  locationToShow: PropTypes.string,
  toggleUpdateZipCodeSidebar: PropTypes.func,
  zipCodeFromUser: PropTypes.string
};
export default React.memo(PDPZipCodeEditLocationUI);